/**
 * iOS Safari selection hardening. CSS user-select alone doesn't stop Safari
 * from *starting* a native selection via long-press or palm gestures while
 * the Pencil is writing — these JS guards kill it at the event layer, and a
 * selectionchange fallback dissolves any selection that slips through.
 * Text fields stay fully editable.
 */
function isEditable(t: EventTarget | null): boolean {
  return (
    t instanceof HTMLElement &&
    (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)
  );
}

export function installSelectionGuards(): void {
  document.addEventListener('selectstart', (e) => {
    if (!isEditable(e.target)) e.preventDefault();
  });
  document.addEventListener('contextmenu', (e) => {
    if (!isEditable(e.target)) e.preventDefault();
  });
  // Last-ditch: if iOS still manages to select something (e.g. system
  // gesture), collapse it immediately so the page never stays highlighted.
  document.addEventListener('selectionchange', () => {
    const sel = document.getSelection();
    if (sel && !sel.isCollapsed && !isEditable(document.activeElement)) {
      sel.removeAllRanges();
    }
  });
}
